var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"consult-buy",class:{ active: _vm.isActive == 3 },on:{"click":_vm.goConsultBuy}},[_c('i',{staticClass:"el-icon-shopping-cart-2",staticStyle:{"font-size":"16px","margin-right":"5px"}}),_vm._v("咨询与购买")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be6afc3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/buttonBuy.vue
// module id = null
// module chunks = 